
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aDOBB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::782de05dc8250ce0f0ef339ccfc93a54>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bf4cd1756672570$var$_react = $7bf4cd1756672570$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7bf4cd1756672570$var$_iconNew = $7bf4cd1756672570$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $7bf4cd1756672570$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShrinkDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/shrink-diagonal
 * Usage guidance:
 * Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bf4cd1756672570$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $7bf4cd1756672570$var$_react.default.createElement($7bf4cd1756672570$var$_iconNew.default, Object.assign({
        name: "ShrinkDiagonalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.72 6.22 13.97.97l1.06 1.06-5.25 5.25zM7.28 9.78l-5.25 5.25-1.06-1.06 5.25-5.25z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M10 6V2H8.5v4.75c0 .414.336.75.75.75H14V6zM2 8.5h4.75a.75.75 0 0 1 .75.75V14H6v-4H2z" clip-rule="evenodd"/>`
    }, props));
$7bf4cd1756672570$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
var $7bf4cd1756672570$var$_default = module.exports.default = $7bf4cd1756672570$var$ShrinkDiagonalIcon;

});


//# sourceMappingURL=shrink-diagonal.034f9639.js.map
